/** Whether the user has an admin role (handles ADMIN, Admin, etc.). */
export function isAdminRole(roles: string[]): boolean {
  return roles.some((role) => role.toUpperCase() === 'ADMIN')
}

export function isProjectUploadContext(context: {
  projectId?: string
  postId?: string
  submissionUpload?: boolean
  scope?: string
  mirrorToProject?: boolean
}): boolean {
  if (context.scope === 'SUBMISSION' || context.postId || context.submissionUpload) {
    return false
  }
  return !!(context.projectId || context.scope === 'PROJECT' || context.mirrorToProject)
}
